import React from 'react';
import { Button } from 'antd';
import { KeyRound, Sparkles } from 'lucide-react';
import { useApiKeyManager } from './ApiKeyManagerProvider';

/**
 * ApiKeyHeaderCTA — drop-in primary button for delegation page headers.
 *
 * Lives in the same slot as Linear's "Connect Linear Workspace" header CTA.
 * Adapts its label based on whether the user has keys:
 *   0 keys → "Get API Key"    (filled primary)
 *   N keys → "Manage API Keys" (ghost secondary)
 *
 * Clicking either opens the full-screen ApiKeyManager modal.
 */
const ApiKeyHeaderCTA = () => {
  const { activeCount, loading, hasLoadedOnce, open } = useApiKeyManager();

  // Don't flash the wrong label while we're still loading the first time
  if (loading && !hasLoadedOnce) {
    return (
      <Button size="large" disabled>
        Loading…
      </Button>
    );
  }

  if (activeCount === 0) {
    return (
      <Button
        type="primary"
        size="large"
        icon={<Sparkles size={16} />}
        onClick={open}
      >
        Get API Key
      </Button>
    );
  }

  return (
    <Button size="large" icon={<KeyRound size={16} />} onClick={open}>
      Manage API Keys
    </Button>
  );
};

export default ApiKeyHeaderCTA;
